import useAuth from "../hooks/useAuth";
import { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { GlobalStateContext } from "../wrappers/GlobalContext";
import { User } from "oidc-client";

function Login() {
    let [searchParams] = useSearchParams();
    const location = useLocation();
    const { setCurrentUser } = useContext(GlobalStateContext);
    const navigate = useNavigate();
    const { getUser } = useAuth();

    const loadUserInfo = async () => {
        const user = await getUser();
        if (user) {            
            setCurrentUser(user)
            navigate("/")
        }
    }

    useEffect(() => {
        if (location.hash.includes("error")) {
            navigate("/fail")
        } else {
            loadUserInfo();
        }
    }, [])
    return (<></>);
}

export default Login;
